/**
 * @deprecated
 * Constants string for dataset names used by dark mode
 */
export enum CompatibleDarkModeDatasetNames {

    /**
     * Original style text color
     */
    OriginalStyleColor = 'ogsc',

    /**
     * Original style background color
     */
    OriginalStyleBackgroundColor = 'ogsb',

    /**
     * Original attribute text color
     */
    OriginalAttributeColor = 'ogac',

    /**
     * Original attribute background color
     */
    OriginalAttributeBackgroundColor = 'ogab',
}
